(ns minorodata.users.events
  (:require [ajax.url :as url]
            [applied-science.js-interop :as js-interop]
            [minorodata.app.api-config :refer [AUTH_API_HOST]]
            [minorodata.app.featurebase]
            [minorodata.app.posthog]
            [minorodata.app.handlers :refer [reg-cofx reg-fx]]
            [minorodata.app.utils :as utils]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))

(reg-fx
 :persist-user
 (fn [user]
   (js/localStorage.setItem
    "minorodata-user"
    (js/JSON.stringify (clj->js user)))))


(reg-fx
 :unpersist-user
 (fn []
   (js/localStorage.removeItem "minorodata-user")))

(reg-fx
 :cleanup
 (fn []
   (js/localStorage.removeItem "environments-panel-active-id")))


(reg-cofx
 :local-user
 (fn [coeffects]
   (assoc coeffects
          :local-user
          (js->clj (js/JSON.parse (js/localStorage.getItem "minorodata-user"))
                   :keywordize-keys true))))


(re-frame/reg-event-fx
 :user.events/refresh-browser-window
 (fn [_ _]
   (js-interop/call-in js/window [:location :reload])))

(re-frame/reg-event-fx
 :user.events/redirect-to-login-page
 (fn [_ _]
   (let [current-url (js-interop/get-in js/window [:location :href])
         login-url (str AUTH_API_HOST
                        "/authorize?"
                        (url/params-to-str :java {:original-url current-url}))]
     (js-interop/call-in js/window [:location :replace] login-url))))

(re-frame/reg-event-fx
 :users.events/login
 (fn [_ [_ form-data]]
   {:async-flow
    {:first-dispatch [:users.api/login-request form-data]
     :rules          [{:when     :seen?
                       :events   :users.api/login-request-success
                       :dispatch [:users.events/auth-redirects]
                       :halt?    true}]}}))


(re-frame/reg-event-fx
 :user.events/redirect-to-logout
 (fn [_ _]
   (let [logout-url (str AUTH_API_HOST "/logout")]
     (js-interop/call-in js/window [:location :replace] logout-url))))

(re-frame/reg-event-fx                                      ;; create new event for logout in a mock component
 :users.events/logout
 (fn [_ _]
   {:dispatch-sync  [[:user/delete]
                     [:mold-http/clear-caches]]
    ;; Give all other effect a chance to finish before reloading the page
    :dispatch-later [{:ms       10
                      :dispatch [:user.events/redirect-to-logout]}]
    :unpersist-user     nil
    :cleanup            nil
    :posthog/reset-user nil
    :featurebase/logout nil}))


(defn- clean-current-url-query! []
  (js/window.history.replaceState
   nil
   ""
   (str (js-interop/get-in js/window [:location :origin])
        (js-interop/get-in js/window [:location :pathname]))))

(re-frame/reg-event-fx
 :user.events/redirect-to-original-url
 (fn [_ [_ original-url]]
   (clean-current-url-query!)
   (js-interop/call-in js/window [:location :replace] original-url)))

(re-frame/reg-event-fx
 :users.events/login-callback
 (fn [_ _]
   (let [{:keys [id-token access-token]}
         @(re-posh/subscribe [:app-route/prop :app-route/query])

         _ (clean-current-url-query!)

         {:keys [client-id client-name user-role user-role-id role-permissions
                 original-url user-id user-email exp]}
         (utils/parse-token id-token)

         user {:user/client-name   client-name
               :user/features      nil
               :user/user          user-email
               :user/roles         [user-role]
               :user/role-id       user-role-id
               :user/exp           (js/parseInt exp)
               :user/uid           user-id
               :user/session-token (or access-token id-token)
               :user/cid           client-id
               :user/permissions   (if (and (some? role-permissions) (empty? role-permissions))
                                     [:none]
                                     role-permissions)}

         ;; PostHog Analytics effects
         posthog-effects {:posthog/identify {:user-id (:user/uid user)
                                             :props   {:email       (:user/user user)
                                                       :client-id   (:user/cid user)
                                                       :client-name (:user/client-name user)
                                                       :role        user-role}}
                          :posthog/group    {:group-type "organization"
                                             :group-id   (:user/cid user)
                                             :props      {:name (:user/client-name user)}}}]

     (if (= "restricted" user-role)
       (merge
        {:dispatch-n             [[:user/add user]
                                  [:app.events/navigate :forbidden]
                                  [:sentry/set-user {:email (:user/user user)}]]
         :persist-user           user
         :unleash/update-context {:userId    (:user/user user)
                                  :client-id client-id}}

        posthog-effects)
       ;; navigate to original-url
       (merge
        {:dispatch-n             [[:user/add user]
                                  [:user.events/redirect-to-original-url original-url]
                                  [:sentry/set-user {:email (:user/user user)}]]
         :persist-user           user
         :unleash/update-context {:userId    (:user/user user)
                                  :client-id client-id}}

        posthog-effects)))))



(re-frame/reg-event-fx
 :users.events/oauth-callback
 (fn [_ _]
   (let [redirect-to (str (js-interop/get-in js/window [:location :origin])
                          "/callback.html"
                          (js-interop/get-in js/window [:location :search]))]
     (js-interop/call-in js/window
                         [:location :replace]
                         redirect-to))))
